import { createApi } from "@reduxjs/toolkit/query/react";
import { getAxiosInstance } from "../../../api";

const axiosBaseQuery =
  () =>
  async ({ params, endpoint, method, body }) => {
    
    const api = await getAxiosInstance();
    const getParams = (key) => {
    
      if (params?.[key]) {
        return `${key}=${params[key]}&`;
      } else {
        return "";
      }
    };

    try {
      const response = await api[method](
        `${endpoint}?id=${
          params?.id || 1
        }`,
        body
      );

      return { data: response.data };
    } catch (axiosError) {
      let err = axiosError;

      return {
        data: err?.response?.data || err.message,
      };
    }
  };

export const homeVideo = createApi({
  reducerPath: "homeVideoApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["homeVideo"],
  endpoints: (builder) => ({
    getListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/v1/admin/home-video/edit`,
      }),
      providesTags: ["homeVideo"],
    }),
    updateStatusById: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/v1/admin/home-video/status`,
      }),

      invalidatesTags: ["homeVideo"],
    }),
  }),
});

export const { useGetListDataQuery, useUpdateStatusByIdMutation } = homeVideo;
